<!--
  ~ Copyright (C) 2025 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<mat-card class="feedback-questions-content-item" *ngIf="answer">
  <div class="results-options">
    <button
      *ngFor="let chart of chartOptions"
      mat-icon-button
      color="primary"
      type="button"
      (click)="onViewTypeChange(chart.type)"
      class="option-item"
      [class.active]="viewType === chart.type"
      [attr.aria-label]="'translations.global.button.select' | transloco"
    >
      <mat-icon aria-hidden="true">{{ chart.icon }}</mat-icon>
    </button>
  </div>

  <div class="item-headline">
    <div class="title large bold" [innerHTML]="title"></div>
    <div class="responses-count">
      {{ 'translations.diagnostics.labels.feedbackAdditionalContentResponses' | transloco: { number: feedbackProviderResponsesCount } }}
    </div>
  </div>

  <ptl-simple-bar-chart *ngIf="viewType === ViewType.Bar" [chartData]="chartData"></ptl-simple-bar-chart>

  <ptl-simple-horizontal-bar-chart *ngIf="viewType === ViewType.Horizontal" [chartData]="chartData"></ptl-simple-horizontal-bar-chart>

  <ptl-simple-pie-chart *ngIf="viewType === ViewType.Pie" [chartData]="chartData"></ptl-simple-pie-chart>

  <ptl-choice-results-table-preview *ngIf="viewType === ViewType.Table" [rows]="chartData"> </ptl-choice-results-table-preview>
</mat-card>
